import React from 'react';
import './coding.styles.scss';

const Coding = () => {
  return (
    <div className="coding-container">
      <div className="service-header">
        <h1>Database Development Services</h1>
        <p>Custom database solutions and stored procedure development</p>
      </div>

      <div className="service-content">
        <section className="service-overview">
          <h2>Custom Database Development</h2>
          <p>
            Our database development services include creating custom stored procedures, 
            functions, triggers, and complete database applications tailored to your 
            specific business requirements.
          </p>
        </section>

        <section className="service-features">
          <h2>Development Services Include:</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Stored Procedures</h3>
              <p>Custom stored procedures for complex business logic and data processing.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔄</div>
              <h3>Triggers & Functions</h3>
              <p>Database triggers and custom functions for automated data handling.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Data Migration</h3>
              <p>Safe and efficient data migration between systems and databases.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔌</div>
              <h3>API Development</h3>
              <p>Database APIs and integration services for seamless connectivity.</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2>Need Custom Database Development?</h2>
          <p>Contact us to discuss your development requirements.</p>
          <button className="contact-btn">Get Started</button>
        </section>
      </div>
    </div>
  );
};

export default Coding;